import { useQuery } from "react-query";
import { IFilterWithoutPageData } from "interfaces/FilterProps";
import { client } from "./api";

type WorkTypeEnum = "Policial" | "Assistente";
type PatrimonialTypeEnum = 1 | 2;

export interface ICoord {
  id: string;
  coords: { x: number; y: number };
  patrimonialType?: PatrimonialTypeEnum;
  status?: string;
  workType?: WorkTypeEnum;
  searchDistance: number;
}
export async function getCoordsService(): Promise<
  IFilterWithoutPageData<ICoord>
> {
  const api = client();
  const response = await api.get<IFilterWithoutPageData<ICoord>>(
    "occurrences/coords"
  );
  return response.data;
}

export function useOccCoords() {
  return useQuery(["occCoords"], () => getCoordsService(), {
    staleTime: 1000 * 60,
  });
}

export async function getHeatmapService() {
  const api = client();
  const response = await api.get<IFilterWithoutPageData<ICoord>>(
    "occurrences/heatmap"
  );
  return response;
}